<template>
	<div class="root szr-box">
		<img class="ldt" v-lazy="require('../../assets/imgs/20250903/szr/pc_index_back.png')"  />
    <div class="sbhd-row1"></div>
		<div class="content">
			<el-row class="one sb-product">
				<el-col :span="24" class="title">
					<img v-lazy="require('../../assets/imgs/20250903/szr/til1.png')" />
				</el-col>
				<el-col :span="24" class="sub-til">接入deepseek、豆包、腾讯混元等二十多种大模型</el-col>
				<el-col :span="4">&nbsp;</el-col>
				<el-col :span="4" class="left">
					<div class="sbp-ball b1">
            <span>适合各类</span>
            <span>场景</span>
					</div>
					<div class="sbp-ball b2">
						<span>7*24h答疑</span>
            <div class="sbp-tips t1">自助迎宾</div>
            <div class="sbp-tips t2">文物讲解</div>
					</div>
					<div class="sbp-ball b3">
						<span>互动娱乐</span>
					</div>
				</el-col>
				<el-col :span="8" class="middle">
					<img v-lazy="require('../../assets/imgs/20250903/szr/2.png')" width="100%"/>
				</el-col>
				<el-col :span="4" class="right">
					<div class="sbp-ball b4">
						<span>设备多样</span>
					</div>
					<div class="sbp-ball b5">
						<span>数字人</span>
            <span>形象定制</span>
            <div class="sbp-tips t3">导览导航</div>
            <div class="sbp-tips t4">图书检索</div>
					</div>
					<div class="sbp-ball b6">
						<span>心理疏导</span>
					</div>
				</el-col>
				<el-col :span="4">&nbsp;</el-col>
			</el-row>
      <el-row class="sb-equipment">
				<el-col :span="24" class="title">
					<img v-lazy="require('../../assets/imgs/20250903/szr/til2.png')" />
				</el-col>
      </el-row>
      <div class="sbeq-list">
        <div class="sbeq-item" v-for="v, i in 15" :key="i">
          <img v-lazy="require(`../../assets/imgs/20250903/szr/eq${v}.png`)" />
        </div>
      </div>
			<el-row class="two">
				<el-col :span="24" class="title">
					<img v-lazy="require('../../assets/imgs/20250903/szr/til3.png')" />
				</el-col>
				<el-col :span="2">&nbsp;</el-col>
				<el-col :span="20">
					<div class="block">
            <el-carousel
              trigger="click"
              :loop="true"
              height="900px"
              indicator-position="outside"
            >
              <el-carousel-item class="carousel-item" v-for="v, i in carouselList" :key="i">
                <img v-lazy="v.cover" />
                <p class="name">{{v.til}}</p>
                <p class="type">{{v.name}}</p>
              </el-carousel-item>
            </el-carousel>
          </div>
				</el-col>
				<el-col :span="2">&nbsp;</el-col>
			</el-row>
      <el-row class="sb-figure">
				<el-col :span="24" class="title">
					<img v-lazy="require('../../assets/imgs/20250903/szr/til4.png')" />
				</el-col>
      </el-row>
      <div class="sbf-list">
        <div class="sbf-item" v-for="v, i in figureList" :key="i">
          <img v-lazy="v.cover" />
          <div class="name">{{ v.name }}</div>
        </div>
      </div>
			<el-row class="two sb-case">
				<el-col :span="24" class="title">
					<img v-lazy="require('../../assets/imgs/20250903/szr/til5.png')" />
				</el-col>
				<el-col :span="2">&nbsp;</el-col>
				<el-col :span="20">
          <el-carousel
            trigger="click"
            :loop="true"
            height="750px"
            indicator-position="none"
          >
            <el-carousel-item class="carousel-item" v-for="v, i in caseList" :key="i">
              <ul class="sbci-wrap">
                <li class="sbciw-sub" v-for="w, j in v.children" :key="j">
                  <img v-lazy="w.cover" />
                  <div class="name ellipsis">{{ w.name }}</div>
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
				</el-col>
				<el-col :span="2">&nbsp;</el-col>
			</el-row>
      <el-row class="sb-advantage">
				<el-col :span="24" class="title">
					<img v-lazy="require('../../assets/imgs/20250903/szr/til6.png')" />
				</el-col>
				<el-col :span="24">
					<img v-lazy="require('../../assets/imgs/20250903/szr/9.png')" />
				</el-col>
      </el-row>
      <el-row class="">
				<el-col :span="24">
					<img v-lazy="require('../../assets/imgs/20250903/szr/10.png')" style="margin-bottom: -10vh;" />
				</el-col>
      </el-row>
		</div>
	</div>
</template>

<script>
	export default {
		name: "pcSzr",
		data() {
			return {
				msg: "这是PC的朗读亭宣传页面",
				tableData: [
					{ name:"设备主体",data:"朗读亭一台（含空调、通风系统、灯光、射灯、玻璃）"},
					{ name: "V G V:", data: "最高可支持1920*1080@fps" },
					{ name: "操作系统:", data: "安卓系统" },
					{ name: "C P U:", data: "触摸点播系统（屏）1 个，21.5液晶\n影像字幕显示屏1 个，32寸液晶\n 主控机1 个" },
					{ name: "显示部分:", data: "安卓系统" },
					{ name: "产品尺寸:", data: "1.26*1.56*2.70M" },
					{ name: "额定电源:", data: "AC220V 50HZ" },
					{ name: "无线连接:", data: "支持网线、WIFI" },
					{ name: "额定功率:", data: "整机为800W,包含空调和通风系统" },
					{ name: "屏幕类型:", data: "主显示器分辨率1920*1080\n触摸屏分辨率，1920*1080" },
					{ name: "软件升级:", data: "支持本地升级/OTA升级" },
					{ name: "设备附件:", data: "专业电容麦克风2个\n专业监听头戴式耳机2个\n空调遥控器1个\n复古座椅2个\n小吧台2个" },
					{ name: "附加功能:", data: "臭氧消毒" }
				],
        tabs: [
          { name: "本地特色", icon: require("../../assets/imgs/20250903/ldt/bdts.png") },
          { name: "活动", icon: require("../../assets/imgs/20250903/ldt/hd.png") },
          { name: "绘本朗读", icon: require("../../assets/imgs/20250903/ldt/hbld.png") },
          { name: "配音", icon: require("../../assets/imgs/20250903/ldt/py.png") },
          { name: "英文评测", icon: require("../../assets/imgs/20250903/ldt/ywpc.png") },
          { name: "中文评测", icon: require("../../assets/imgs/20250903/ldt/zwpc.png") },
          { name: "背诵", icon: require("../../assets/imgs/20250903/ldt/bs.png") },
          { name: "心理健康", icon: require("../../assets/imgs/20250903/ldt/xljk.png") },
        ],
        carouselList: [
          { til: '医护', name: "AI辅助精准诊断、治疗方案讲解及患者健康监测，赋能医导质量与效率双提升。", cover: require("../../assets/imgs/20250903/szr/4.png") },
          { til: '商场', name: "行为分析与智能推荐，优化商品讲解、个性化促销，提升客流量转化与消费体验。", cover: require("../../assets/imgs/20250903/szr/5.png") },
          { til: '政务', name: "智能政务助手，实现政策咨询自动化、审批流程及服务精准化，政务服务现代化。", cover: require("../../assets/imgs/20250903/szr/6.png") },
          { til: '文旅景区', name: "虚拟导览带游客沉浸式互动体验，优化游客规划，重塑文旅场景的数字化新体验。", cover: require("../../assets/imgs/20250903/szr/7.png") },
          { til: '图书馆', name: "智能检索算法与读者偏好分析，实现图书精准推荐、打造个性化知识服务空间。", cover: require("../../assets/imgs/20250903/szr/8.png") },
        ],
        caseList: [
          {
            children: [
              { name: "江西都昌交警大队", cover: require("../../assets/imgs/20250903/szr/c1.png") },
              { name: "辽宁安图社区敬老协会", cover: require("../../assets/imgs/20250903/szr/c2.png") },
            ]
          },
          {
            children: [
              { name: "江西农业工程职业学院", cover: require("../../assets/imgs/20250903/szr/c3.png") },
              { name: "青海果洛州达日县图书馆", cover: require("../../assets/imgs/20250903/szr/c4.png") },
            ]
          },
          {
            children: [
              { name: "甘肃省武威市凉州区社区阅读站", cover: require("../../assets/imgs/20250903/szr/c5.png") },
              { name: "广州华盛", cover: require("../../assets/imgs/20250903/szr/c6.png") },
            ]
          },
        ],
        figureList: [
          { name: "政务", cover: require("../../assets/imgs/20250903/szr/p1.png") },
          { name: "小美", cover: require("../../assets/imgs/20250903/szr/p2.png") },
          { name: "古风", cover: require("../../assets/imgs/20250903/szr/p3.png") },
          { name: "动物", cover: require("../../assets/imgs/20250903/szr/p4.png") },
          { name: "商务", cover: require("../../assets/imgs/20250903/szr/p5.png") },
          { name: "诗人", cover: require("../../assets/imgs/20250903/szr/p6.png") },
          { name: "医护", cover: require("../../assets/imgs/20250903/szr/p7.png") },
          { name: "真人", cover: require("../../assets/imgs/20250903/szr/p8.png") },
        ],
			};
		}
	};
</script>

<style scoped>
	.ldt {
		position: relative;
		top: -27vh;
		left: -14vw;
	}
	.title {
		margin-bottom: 8vh;
		margin-top: 2vh;
	}
	.left p,
	.right p {
		text-align: left;
		color: #999999;
    min-height: 72px;
	}
	.left img,
	.right img {
		margin-bottom: 2vh;
	}
	.iconlist {
		position: relative;
		top: -28vh;
	}
	.iconlist p {
		margin-top: 2vh;
		font-size: 24px;
		font-weight: bolder;
	}
	.one{
		margin-top: 8vh;
	}
	.three,.four{
		margin-top: 17vh;
	}
	.two {
		background-image: url("../../assets/imgs/swiperback.png");
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}
	.block .name {
		font-size: 30px;
		font-weight: bolder;
	}
	.block .type {
		font-size: 25px;
		font-weight: bolder;
		color: #890101;
	}
	.swiperback {
		float: right;
		position: absolute;
		left: 45vw;
		top: 20vh;
	}
  .carousel-item img{
    height: 743px;
    max-width: 100%;
    object-fit: contain;
  }
  .case-item img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .sbhd-row1{
    position: relative;
    height: 16.3vw;
  }
  .sbhd-row1::after{
    position: absolute;
    content: '';
    top: -42px;
    left: 0;
    width: 100%;
    height: 463px;
    background: url("../../assets/imgs/20250903/szr/1.png") no-repeat center/contain;
  }
  .sb-product{
    margin-bottom: 12.3vh;
  }
  .sb-product .left{
    margin-top: 62px;
  }
  .sb-product .right{
    margin-top: 72px;
  }
  .sb-product .title{
    margin-bottom: 6.5vh;
  }
  .sb-product .sub-til{
    font-weight: 400;
    font-size: 30px;
    color: #8D8D8D;
    margin-bottom: 7vh;
  }
  .sb-product .middle{
    height: 877px;
    background: url("../../assets/imgs/20250903/szr/3.png") no-repeat center/contain;
  }
  .sb-product .middle img{
    width: 294px;
    height: 100%;
  }
  .sbp-ball{
    width: 201px;
    height: 201px;
    background: #890000;
    border-radius: 50%;
    opacity: 0.9;
    font-weight: 500;
    font-size: 30px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 18px;
    box-sizing: border-box;
    text-align: center;
    font-family: PingFang SC;
    position: relative;
  }
  .b1{
    opacity: 0.6;
    margin-left: 174px;
    margin-bottom: 81px;
  }
  .b3{
    width: 141px;
    height: 141px;
    font-size: 26px;
    opacity: 0.3;
    margin-left: 130px;
    margin-top: 99px;
  }
  .b4{
    width: 160px;
    height: 160px;
    font-size: 26px;
    opacity: 0.4;
    margin-left: 20px;
    margin-bottom: 80px;
  }
  .b5{
    width: 232px;
    height: 232px;
    font-size: 35px;
    margin-left: 71px;
  }
  .b6{
    width: 190px;
    height: 190px;
    margin-left: 77px;
    margin-top: 105px;
    opacity: 0.7;
  }
  .sbp-tips{
    position: absolute;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 26px;
    color: #890000;
    opacity: 0.2;
    white-space: nowrap;
  }
  .t1{
    top: -16px;
    left: calc(100% + 8px);
  }
  .t2{
    top: calc(100% + 65px);
    left: -24px;
  }
  .t3{
    top: -54px;
    right: -24px;
  }
  .t4{
    top: calc(100% + 53px);
    left: 67px;
  }
  .sbeq-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 0 347px 160px;
  }
  .sbeq-item{
    width: 18.11%;
    height: 13.07vw;
    background: #FFFFFF;
    border-radius: 10px;
    border: 3px solid #EDEDED;
    box-sizing: border-box;
    padding: 14px;
  }
  .sbeq-item:nth-child(n+6){
    margin-top: 1.96%;
  }
  .sbeq-item:not(:nth-child(5n+1)){
    margin-left: 0.94%;
  }
  .sbeq-item img{
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .sb-figure{
    padding-top: 160px;
  }
  .sbf-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 0 300px;
  }
  .sbf-item{
    width: 16.288%;
    box-sizing: border-box;
    margin: 0 4.319%;
  }
  .sbf-item img{
    width: 100%;
    /* height: 221px; */
    border-radius: 50%;
    object-fit: cover;
  }
  .sbf-item .name{
    font-weight: 500;
    font-size: 1.5625vw;
    color: #231815;
    margin-top: 20px;
  }
  .sbf-item:nth-child(n+5){
    margin-top: 65px;
  }
  .sb-case{
    margin-top: 160px;
    background-image: url("../../assets/imgs/20250903/szr/bg1.png");
  }
  .sbci-wrap{
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .sbciw-sub{
    width: 47.75%;
    height: 37.81vw;
    background-color: #fff;
    border-radius: 10px;
    border: 3px solid #EDEDED;
    box-sizing: border-box;
    list-style: none;
  }
  .sbciw-sub img{
    width: 100%;
    height: 32.76vw;
    object-fit: cover;
  }
  .sbciw-sub .name{
    line-height: 86px;
    font-weight: 500;
    font-size: 35px;
    color: #333333;
    padding: 0 15px;
  }
  .sb-advantage .title{
    margin: 160px auto 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pc/szr.vue